import { render, staticRenderFns } from "./CreateContrat.vue?vue&type=template&id=588b59c2&"
import script from "./CreateContrat.vue?vue&type=script&lang=ts&"
export * from "./CreateContrat.vue?vue&type=script&lang=ts&"
import style0 from "./CreateContrat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports